import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import utils from './../../../lib/utils';
import './index.scss';

export default class ResetPassword extends React.Component {
  constructor() {
    super();

    this.state = {
      passwordMismatch: false,
      blankPassword: false,
    };

    this.fpId = null;

    this.onForgotFormSubmit = this.onForgotFormSubmit.bind(this);
  }

  componentDidMount() {
    // Get forgot password ID from URL
    this.fpId = utils.getURLParameterByName('ID');
    this.props.getForgotPassword(this.fpId);
  }

  onForgotFormSubmit(event) {
    event.preventDefault();

    this.props.postResetPasswordStart();

    const oldPassword = event.target.oldPassword.value;
    const newPassword = event.target.newPassword.value;

    if (!oldPassword || !newPassword) {
      this.setState({
        blankPassword: true,
      });
    } else if (oldPassword !== newPassword) {
      this.setState({
        passwordMismatch: true,
        blankPassword: false,
      });
    } else {
      this.setState(
        {
          passwordMismatch: false,
          blankPassword: false,
        },
        () => {
          this.props.postResetPassword({
            requestId: this.fpId,
            newPassword,
          });
        },
      );
    }
  }

  render() {
    let message = '';
    let isError = true;
    if (this.props.auth.forgotPasswordRequestVerify === false) {
      message = (
        <p className="message--big">
          Sorry! Your password reset link has expired.
        </p>
      );
      isError = true;
    }

    if (this.state.passwordMismatch) {
      message = 'The passwords do not match.';
      isError = true;
    }

    if (this.state.blankPassword) {
      message = 'Please check the passwords you have entered.';
      isError = true;
    }

    if (this.props.auth.saveResetPassword === true) {
      message = (
        <p className="message--big">
          Congrats! Password updated successfully. Please &nbsp;
          <NavLink to="/login">sign in</NavLink>&nbsp; to continue.
        </p>
      );
      isError = false;
    }

    if (this.props.auth.saveResetPassword === false) {
      message = 'Sorry! Unable to reset your password.';
      isError = true;
    }

    return (
      <div className="auth-reset-password">
        <div className="auth-reset-password__container">
          <h4>Reset Password?</h4>
          <div
            className={classnames('message', {
              'message--success': !isError,
              'message--error': isError,
            })}
          >
            {message}
          </div>
          {this.props.auth.forgotPasswordRequestVerify === false ||
          this.props.auth.saveResetPassword === true ? (
            undefined
          ) : (
            <form onSubmit={this.onForgotFormSubmit}>
              <div className="form-group">
                <label htmlFor="oldPassword">Enter New Password</label>
                <input type="password" name="oldPassword" />
              </div>
              <div className="form-group">
                <label htmlFor="newPassword">Re-enter new Password</label>
                <input type="password" name="newPassword" />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn--primary btn--lg">
                  Submit
                </button>
              </div>
            </form>
          )}
          <div className="auth-reset-password__container__sign-up">
            Already have a TrueLark account? &nbsp;{' '}
            <NavLink to="/login">Sign in</NavLink>
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.defaultProps = {
  getForgotPassword: () => {},
  postResetPassword: () => {},
  postResetPasswordStart: () => {},
  auth: {
    forgotPasswordRequestVerify: false,
    saveResetPassword: false,
  },
};

ResetPassword.propTypes = {
  getForgotPassword: PropTypes.func,
  postResetPassword: PropTypes.func,
  postResetPasswordStart: PropTypes.func,
  auth: PropTypes.shape({
    forgotPasswordRequestVerify: PropTypes.bool,
    saveResetPassword: PropTypes.bool,
  }),
};
